<router-outlet></router-outlet>

<!-- Toast global -->
<p-toast position="top-center" [breakpoints]="{ '920px': { width: '80%' } }"></p-toast>

<!-- Interceptor -->
<mdk-spinner [interceptor]="inProgress"></mdk-spinner>